import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Textarea, Checkbox } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const TextAreaField = (props) => (
  <Textarea
    {...props}
    input={{
      ...props.input,
      rows: 7,
    }}
  />
);
const DangerousData = ({
  product_group_id,
  is_dangerous,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/product_groups/${product_group_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer", "brand", "root_taxon"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Informacje o bezpieczeństwie", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <style>{`.check-group{margin: 0;}`}</style>
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field
          label="Produkt niebezpieczny"
          name="is_dangerous"
          component={Checkbox}
        />
        {is_dangerous && (
          <>
            <Field
              name="safety_warnings"
              label="Ostrzeżenia dotyczące bezpieczeństwa"
              component={TextAreaField}
            />
            <Field
              name="possible_risks"
              label="Możliwe zagrożenia"
              component={TextAreaField}
            />
            <Field
              name="instructions_for_use"
              label="Instrukcje dotyczące użytkowania"
              component={TextAreaField}
            />
          </>
        )}
      </form>
    </Dashboard>
  );
};

export default reduxForm({
  form: "update-product-group-dangerous",
  enableReinitialize: true,
})(DangerousData);
